// extracted by mini-css-extract-plugin
module.exports = {"scrollStyle":"index_scrollStyle__3Qytt"};